import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  ShiftTemplateSettingsItem,
  ShiftTemplatesSettingsResponse,
} from "@/actions/ssr/settings/getShiftTemplatesSettingsSSR";

interface SettingsFlexibleShiftTemplatesState {
  items: ShiftTemplateSettingsItem[];
  totalPages: number;
  currentPage: number;
  totalItems: number;
}

const initialState: SettingsFlexibleShiftTemplatesState = {
  items: [],
  totalPages: 1,
  currentPage: 1,
  totalItems: 0,
};

const settingsFlexibleShiftTemplatesSlice = createSlice({
  name: "settingsFlexibleShiftTemplates",
  initialState,
  reducers: {
    setSettingsFlexibleShiftTemplates(
      state,
      action: PayloadAction<ShiftTemplatesSettingsResponse | null>,
    ) {
      if (!action.payload) return;
      state.items = action.payload.results;
      state.totalPages = action.payload.total_pages;
      state.currentPage = action.payload.current_page;
      state.totalItems = action.payload.count;
    },
    setSettingsFlexibleShiftTemplateItems(
      state,
      action: PayloadAction<ShiftTemplateSettingsItem[]>,
    ) {
      state.items = action.payload;
    },
    setSettingsFlexibleShiftTemplatePagination(
      state,
      action: PayloadAction<{
        totalPages: number;
        currentPage: number;
        totalItems?: number;
      }>,
    ) {
      state.totalPages = action.payload.totalPages;
      state.currentPage = action.payload.currentPage;
      if (action.payload.totalItems !== undefined) {
        state.totalItems = action.payload.totalItems;
      }
    },
  },
});

export const {
  setSettingsFlexibleShiftTemplates,
  setSettingsFlexibleShiftTemplateItems,
  setSettingsFlexibleShiftTemplatePagination,
} = settingsFlexibleShiftTemplatesSlice.actions;
export default settingsFlexibleShiftTemplatesSlice.reducer;
